import { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { Box, Stepper, Button, CircularProgress, LinearProgress, Snackbar, Alert } from '@mui/material';

import Questions from '../../Components/Questions/Questions.jsx';
import ProgressBar from '../../Components/ProgressBar/ProgressBar.jsx';
import ProgressBarSingle from '../../Components/ProgressBarSingle/ProgressBarSingle.jsx';

import prevArrow from '../../Assets/Images/prev-arrow.svg';
import prevArrowBlack from '../../Assets/Images/prev-arrow-black.svg';
import nextArrow from '../../Assets/Images/next-arrow.svg';
import nextArrowWhite from '../../Assets/Images/next-arrow-white.svg';
import playBtnImg from "../../Assets/Images/play-btn.svg";
import useWindowDimensions from '../../Hooks/useWindowDimensions.js';
// import AssessmentProgressContext from '../Store/AssessmentProgressContext';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';
import QuestionsProgressContext from '../../Store/QuestionsProgressContext';
import QuestionInfo from '../../Components/QuestionInfo/QuestionInfo.jsx';
import { questions_statistics } from '../../temp.js';
import bulbImg from '../../Assets/Images/bulb.png'
import AssessmentAdditionalV3 from '../AssessmentAdditionalV3/AssessmentAdditionalV3.jsx';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import playIcon from "../../Assets/Images/play-icon.svg";
// import videoThumbnail from "../../Assets/Images/thumbnail5.png";
// import videoThumbnail from "../../Assets/Images/thumbnail2.png";
import videoThumbnail from "../../Assets/Images/thumbnail.png";


const AssessmentV3 = () => {

  // const assessProgressCtx = useContext(AssessmentProgressContext);
  // console.log("assessProgressCtx", assessProgressCtx);
  const assessCtx = useContext(AssessmentQuestionContext);
  const questionsCtx = useContext(QuestionsProgressContext);
  const [selectedAnswer, setSelectedAnswer] = useState('')

  const { windowWidth } = useWindowDimensions();
  let navigate = useNavigate();
  const { id, pageId } = useParams();

  console.log("pageId", pageId);

  // useEffect(() => {
  //   assessCtx.view ? setShowStatistics(true) : setShowStatistics(false);
  //   assessCtx.updateSetStatView(false);
  // }, [assessCtx.view]);

  useEffect(() => {
    // document.body.style.backgroundColor = "#E5E5E5";

    setIsLoading(true);
    getQuestions();
    sessionStorage.removeItem("backFromDetailsPage");
    // setQs(questions);
    // if(id != null) {      
    //   getAssessment();
    // } else {
    //   getQuestions();
    // }

    // getOldQuestions();

    // assessProgressCtx.updateMainSectionsStatus(assessProgressCtx?.mainSections?.map(sec => {
    //   if(sec.title === "Response") return { ...sec, status: "active" };
    //   else return { ...sec, status: "unfinished" };
    // }));

  }, [pageId]);

  // useEffect(() => {
  //   getQuestions();
  // }, [pageId]);

  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [nextValue, setNextValue] = useState(0);
  const [sections, setSections] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionCount, setQuestionCount] = useState(0);
  const [currentHash, setCurrentHash] = useState(0);
  const [hasAdditional, setHasAdditional] = useState(false);
  const [qs, setQs] = useState([]);
  const [apiData, setApiData] = useState();
  const [oldQuestions, setOldQuestions] = useState();
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [prevBtnClicked, setPrevBtnClicked] = useState(false);
  const [showStatistics, setShowStatistics] = useState(true);
  const [isSubmittingAnswer, setIsSubmittingAnswer] = useState(false);
  const [answerSubmissionError, setAnswerSubmissionError] = useState(false);
  const [onLastStatisticsPage, setOnLastStatisticsPage] = useState(false);
  const [goBackToPrevQ, setGoBackToPrevQ] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [isSaving, setIsSaving] = useState(false);
  const submitAnsTimeoutRef = useRef();
  const videoRef = useRef(null);

  const questionType = questions?.[activeStep]?.answerType;
  const questionsWithoutStats = [22, 23];
  const defaultErrorMessage = "An unexpected error occurred while submitting answers. Please try again later.";

  // console.log("searchParams.get('member')", searchParams.get("member"));

  // useEffect(() => {
  //   const ansNotNullUndefined = questions?.[activeStep]?.answer !== undefined && questions?.[activeStep]?.answer !== null;
  //   if (activeStep === (questions?.length - 1)) {
  //     if (ansNotNullUndefined && questions?.[activeStep]?.answer >= 0) {
  //       setShowStatistics(false);
  //     } else setShowStatistics(true);
  //   }
  // }, []);

  const showSnackbar = (msg, severity) => {
    setErrorMsg(msg);
    setAlertSeverity(severity);
    setSnackbarOpen(true);
  };

  // internet connection check
  useEffect(() => {
    // Check connectivity on mount
    if (!navigator.onLine) {
      showSnackbar("You are not connected to the internet. Try again later.", "error");
    }

    // Handler for going offline
    const handleOffline = () => {
      showSnackbar("You are not connected to the internet. Try again later.", "error");
    };

    // Handler for going online
    const handleOnline = () => {
      showSnackbar("Internet connection restored.", "success");
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (submitAnsTimeoutRef.current) {
        clearTimeout(submitAnsTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (showStatistics) {
      document.body.style.backgroundColor = "#242223";
    } else {
      document.body.style.backgroundColor = "#FFFFFF";
    }
  }, [showStatistics]);

  useEffect(() => {
    // to hide Next button when user has just answered the question (500ms delay) and 
    // to show it again when user clicks on Prev button

    let timeoutId = null;
    let conditionToShowNextBtn = (
      (questions?.[activeStep]?.answerType !== "slider" &&
        questions?.[activeStep]?.answerType !== "multiple_choice" &&
        questions?.[activeStep]?.answerType !== "month_year") ||
      (questions?.[activeStep]?.answer >= 0));

    if (conditionToShowNextBtn && !prevBtnClicked && ((activeStep <= (questions.length - 1)) && showStatistics)) {
      timeoutId = setTimeout(() => {
        setShowNextBtn(true);
      }, 500);
    }

    if (conditionToShowNextBtn && prevBtnClicked) {
      setPrevBtnClicked(false);
      setShowNextBtn(true);
    }

    if (!conditionToShowNextBtn) {
      setShowNextBtn(false);
    }

    if (showStatistics && (activeStep < (questions.length - 1))) {
      setShowNextBtn(true);
    }

    if (!showStatistics && (activeStep === (questions.length - 1))) {
      setShowNextBtn(false);
    }

    checkNextBtnDisabled();

    return () => {
      clearTimeout(timeoutId);
    }
  }, [prevBtnClicked, activeStep, questions, showStatistics]);

  useEffect(() => {
    console.log("Do we run??");
    let isDisplay = true;
    // Get all standalone logic (ie parent_id = 0)
    let displayLogic = questions[activeStep]?.logic.filter(obj => obj.parent_id == 0 && obj.logic_type == "display");
    console.log("displayLogic", displayLogic);

    if (displayLogic && displayLogic.length > 0) {
      
      for (let l = 0; l < displayLogic.length; l++) {
        
        let currentLogic = [];
        currentLogic.push(displayLogic[l]);
        let childLogic = questions[activeStep]?.logic.filter(obj => obj.parent_id == displayLogic[l].id);
        currentLogic.push(...childLogic);
        console.log("currentLogic", currentLogic);
        
        if (currentLogic.length > 1) {
          console.log("getOperatorLogic", getOperatorLogic(getQuestionBasedOnVariable(questions, questions[activeStep]?.logic[l]?.variable).answer, questions[activeStep]?.logic[l]?.operator, questions[activeStep]?.logic[l]?.value));
          let subDisplay = 0;
          for (let c = 0; c < currentLogic.length; c++) {
            if (getOperatorLogic(getQuestionBasedOnVariable(questions, currentLogic[c].variable).answer, currentLogic[c].operator, currentLogic[c].value)) {
              subDisplay++;
            }
          }
          if (subDisplay == currentLogic.length) {
            isDisplay = false;
          }
        } else {
          console.log("THIS IS RUNNING");
          console.log(getQuestionBasedOnVariable(questions, questions[activeStep]?.logic[l]?.variable).answer);
          if (getOperatorLogic(getQuestionBasedOnVariable(questions, questions[activeStep]?.logic[l]?.variable).answer, questions[activeStep]?.logic[l]?.operator, parseInt(questions[activeStep]?.logic[l]?.value))) {
            isDisplay = false;
          }
        }
      }

    }

    if (!isDisplay) {
      console.log("DOES THIS WORK??");
      assessCtx.updateSkipStatus(questions?.[activeStep]?.id, true);
      setQuestions(questions?.map((q) => {
        if (q.id === questions?.[activeStep]?.id) q.skip = true;
        return q;
      }))
    } else {
      assessCtx.updateSkipStatus(questions?.[activeStep]?.id, false);
      setQuestions(questions?.map((q) => {
        if (q.id === questions?.[activeStep]?.id) q.skip = false;
        return q;
      }))
    }
    
    if (!isDisplay && !goBackToPrevQ) {
      console.log("NEXT QUESTION PLEASE");
      if (assessCtx.questions?.[activeStep]?.skip) {
        setActiveStep(activeStep + 1);
      }
    } else if (!isDisplay && goBackToPrevQ) {
      const idx = activeStep || 0;
      for (let i = idx; i >= 0; i--) {
        if (!assessCtx.questions?.[i]?.skip) {
          setActiveStep(i);
          break;
        }
      }
      setGoBackToPrevQ(false);
    }
  }, [activeStep, assessCtx, goBackToPrevQ]);

  // useEffect(() => {
  //   if (sessionStorage.getItem("backFromAddQPage") === "true" && questions?.length) {
  //     console.log("activeStep", activeStep); console.log("questions", questions);
  //     setActiveStep(questions?.length - 1);
  //     sessionStorage.removeItem("backFromAddQPage");
  //   }
  // }, [questions, pageId]);

  useEffect(() => {
    if (questions?.[activeStep]?.orderNo === questions?.length) {
      setOnLastStatisticsPage(true);
    } else setOnLastStatisticsPage(false);
  }, [questions, activeStep]);



  function getAssessment() {
    // fetch(process.env.REACT_APP_API_URI + '/v1/assessment/' + id + '/review', {
    // 	method: 'GET',
    // 	mode: 'cors',
    // 	headers: { 'Content-Type': 'application/json' }
    // }).then(response => {
    // 	return response.json();
    // }).then(data => {
    // 	if(data.status == "success") {
    // 		setSections(data.sections);
    // 		setQuestions(data.questions);
    //     setQuestionCount(data.questions?.length);
    //     if((data.hasAdditional === "yes") || (data.hasAdditional === true)) setHasAdditional(true);
    //     setIsLoading(false);
    //     setActiveStep(data.questions?.length - 1);
    //     setCurrentHash(id);
    // 	} else {
    // 		// setOpenSnackbar(true);
    // 	}
    // });
  }

  function getQuestions() {

    // if(assessCtx.questions?.length > 0) {
    //   console.log("assessCtx.questions", assessCtx.questions);
    //   setQuestions(assessCtx.questions);
    //   setQuestionCount(assessCtx.questions?.length);
    //   setIsLoading(false);

    //   // go to the last additional question if coming back from Details page 
    //   // typeof sessionStorage.getItem("backFromDetailsPage") is string so "true"
    //   if(sessionStorage.getItem("backFromDetailsPage") === "true") {
    //     setActiveStep(assessCtx.questions?.length - 1);
    //   } else {
    //     // go to the first unanswered question 
    //     for (let i = 0; i < assessCtx.questions?.length; i++) {
    //       if(!assessCtx.questions?.[i]?.answer && !assessCtx.questions?.[i]?.answerTxt) {
    //         setActiveStep(i);
    //         break;
    //       } else setActiveStep(assessCtx.questions?.length - 1);
    //     }
    //   }
    // }
    // else {

    let clientId = process.env.REACT_APP_CLIENT_ID;
    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id + '/pages/' + pageId, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status == "success") {
        console.log(data);
        let questions = data.data?.questions;
        if (retrieveStoredAnswers()) {
          let answeredQuestions = [];
          let storedQuestions = retrieveStoredAnswers();
          questions?.forEach(q => {
            let question = storedQuestions.find(obj => obj.id == q.id);
            if (question) {
              q.answerTxt = question.answerTxt;
              q.answer = question.answer;
              q.answers = question.answers;
            }
          })
        }
        // setSections(data.sections);
        // setQuestions(data.questions);
        // setQuestionCount(data.questions?.length);
        // assessCtx.addQuestions(questions);
        // if((data.hasAdditional === "yes") || (data.hasAdditional === true)) setHasAdditional(true);

        // go to first unanswered question 
        let goingForward = sessionStorage.getItem("goingForward") === "true" ? true : false;

        const jumpToUnansweredQuestion = () => {
          let sortedQuestions = data?.data.questions;
          sortedQuestions = sortedQuestions?.sort((a, b) => a.orderNo - b.orderNo);
          for (let i = 0; i < sortedQuestions?.length; i++) {
            if (sortedQuestions?.[i]?.answer == undefined && assessCtx.questions?.[i]?.answer !== 0) {
              setActiveStep(i);
              break;
            } else setActiveStep(sortedQuestions?.length - 1);
          }
        }

        if (goingForward) {
          setActiveStep(0);
          sessionStorage.removeItem("goingForward");
        }
        else jumpToUnansweredQuestion();

        setSections(data?.data.sections);
        setQuestions(data?.data.questions);
        assessCtx.addQuestions(questions);
        setQuestionCount(data?.data.questions?.length);
        console.log("QUESTIONS", data?.data.questions);
        console.log("QUESTIONS", data?.data);
        setApiData(data.data);
        setIsLoading(false);
      } else {
        // setOpenSnackbar(true);
        console.error("Error while fetching questions...", data);
        setIsLoading(false);
      }
    }).catch((err) => {
      console.error("Error while fetching questions...", err);
      setIsLoading(false);
    });
    // }
  }

  // useEffect(() => {
  //   setQuestions(apiData);
  // }, [apiData])

  console.log("apiData", apiData);

  const currentSectionName = sections?.find(section => section.id === questions?.[activeStep]?.sectionId)?.section;

  console.log("hasAdditional", hasAdditional);

  function completeAssessment() {

    setIsLoading(true);
    setErrorMsg("");
    let clientId = process.env.REACT_APP_CLIENT_ID;

    let isReview = false;
    if (id != null) {
      isReview = true;
    }

    const jsonBody = { pageId: 1052, questions: questions, isReview: isReview }

    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id, {
      method: 'PUT', mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonBody)
    }).then(response => {
      if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        if (response.status >= 500) {
          error.message = "Server error: Failed to submit answers. Please try again later.";
        } else {
          error.message = defaultErrorMessage;
        }
        throw error;
      }
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        sessionStorage.removeItem("assessmentAnswers");
        markAssessmentAsCompleted();
        console.log("data", data);
      } else {
        // setIsSaving(false);
        // setOpenSnackbar(true);
        showSnackbar(defaultErrorMessage, "error");
      }
    }).catch((err) => {
      console.error("Failed to submit answers...", err);
      setIsLoading(false);
      showSnackbar(err.message || defaultErrorMessage, "error");
    }).finally(() => {
      setIsLoading(false);
    });

  }

  function markAssessmentAsCompleted() {
    setErrorMsg("");
    setIsLoading(true);
    setIsSaving(true);
    fetch(process.env.REACT_APP_API_URI + '/v5/user/assessment/' + id + '/completed', {
      method: 'PUT', mode: 'cors', headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        if (response.status >= 500) {
          error.message = "Server error: Something went wrong while finishing your assessment. Please try again shortly.";
        } else {
          error.message = defaultErrorMessage;
        }
        throw error;
      }
      return response.json();
    }).then(data => {
      if(data.status === "success") {
        setIsLoading(false);
        setIsSaving(false);
        // const assessmentName = sessionStorage.getItem("assessmentName");
        // navigate(`/${assessmentName}/outro/${id}/?${searchParams}`, { replace: true });
        navigate(`/results/${id}/?${searchParams}`, { replace: true });
      } else {
        console.error("Failed to mark assessment as completed...", data);
        showSnackbar(defaultErrorMessage, "error");
      }
    }).catch((err) => {
      console.error("Failed to mark assessment as completed...", err);
      showSnackbar(err.message || defaultErrorMessage, "error");
    }).finally(() => {
      setIsLoading(false);
      setIsSaving(false);
    });
  }

  console.log("searchParams", [...searchParams]);

  const retrieveStoredAnswers = () => {
    if (typeof window !== 'undefined') {
      // Get the current session storage
      let savedAnswers = JSON.parse(sessionStorage.getItem("assessmentAnswers"));
      if (savedAnswers && savedAnswers.length != 0) {
        return savedAnswers;
      }
    }
    return;
  }

  const prevQuestion = () => {
    setGoBackToPrevQ(true);

    if (activeStep > 0) {
      if (showStatistics) {
        // If currently on statistics, go back to the question
        setShowStatistics(false);
        setActiveStep((prev) => prev - 1);
      } else if (questionsWithoutStats.includes(questions?.[activeStep - 1]?.orderNo)) {
        // If previous question has no statistics, just go to previous question
        setActiveStep((prev) => prev - 1);
        setShowStatistics(false);
      } else {
        // Otherwise, show statistics for the previous question
        setShowStatistics(true);
      }
    } else if (activeStep === 0) {
      if (!showStatistics) {
        setShowStatistics(true);
      } else {
        // Already at first question's statistics, so go back to /how-it-works
        // navigate(`/how-it-works/${id}?${searchParams}`, { replace: true });
        // instead of going to /how-it-works, go back to the very first page with ID
        navigate(`/${id}?${searchParams}`, { replace: true });
      }
    }
  };

  const nextQuestion = () => {

    assessCtx.updateAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answer);
    assessCtx.updateTextAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answerTxt);

    if (questionType === "checkbox") {
      assessCtx.updateCheckboxAnswer(questions?.[activeStep].id, questions?.[activeStep].answers);
      submitAnswer(0); // does not matter what we pass as answer arg as answers array is used for checkbox 
      // and answer is being set from questions state variable which is sum (length) of all checked options 
    }

    const ansNotNullUndefined = questions?.[activeStep]?.answer !== undefined && questions?.[activeStep]?.answer !== null;
    const isLastQuestion = activeStep === questions?.length - 1;

    if (showStatistics) {
      setShowStatistics(false);
      return;
    }

    if (questionsWithoutStats.includes(questions?.[activeStep]?.orderNo)) {
    // If this question doesn't have statistics, just go to next question
      if (!isLastQuestion) {
        setActiveStep((prev) => prev + 1);
        setShowStatistics(false);
      } else if (ansNotNullUndefined && questions?.[activeStep]?.answer >= 0) {
        setTimeout(() => { completeAssessment(); }, 500);
      }
      return;
    }

    // For normal questions with statistics
    if (ansNotNullUndefined && questions?.[activeStep]?.answer >= 0) {
      if (!isLastQuestion) {
        setActiveStep((prev) => prev + 1);
        setShowStatistics(true);
      } else {
        setTimeout(() => { completeAssessment(); }, 500);
      }
    }

  };
  

  const submitAnswer = (answer) => {

    let jsonBody = {
      // "id": questions?.[activeStep]?.id,
      "pageId": pageId,
      "answer": answer,
      "answerTxt": null,
      "answerChecked": false,
    }

    if (questionType === "checkbox") {
      jsonBody = {
        // "id": questions?.[activeStep]?.id,
        "pageId": pageId,
        // "answer": answer,
        "answer": questions?.[activeStep]?.answer,
        "answers": questions?.[activeStep]?.answers,
        "answerTxt": null,
        "answerChecked": true,
      }
    }
    console.log("jsonBody", jsonBody);

    setIsSubmittingAnswer(true);
    setAnswerSubmissionError(false);
    setNextBtnDisabled(true); // disable Next button while submitting answer

    // Move to next question after 500ms, regardless of API response
    submitAnsTimeoutRef.current = setTimeout(() => {
      if (activeStep < (questions?.length - 1)) {
        if (questionsWithoutStats.includes(questions?.[activeStep]?.orderNo)) {
          setShowStatistics(false);
          setActiveStep((prev) => prev + 1);
        } else {
          setShowStatistics(true);
          setActiveStep((prev) => prev + 1);
        }
      } else {
        completeAssessment();
      }
      // setNextBtnDisabled(false); // Re-enable Next button after navigation
      // checkNextBtnDisabled();
      setIsSubmittingAnswer(false);
    }, 500);

    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id + '/question/' + questions?.[activeStep]?.id, {
      method: 'PUT', mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonBody)
    }).then((response) => {
      if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        if (response.status >= 500) {
          error.message = "Server error: Failed to submit answer for Question " + questions?.[activeStep]?.orderNo;
          // showSnackbar is invoked in the catch block
        } else {
          error.message = "An unexpected error occurred while submitting answer for Question " + questions?.[activeStep]?.orderNo + ". Please try again later.";
        }
        throw error;
      }
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        setAnswerSubmissionError(false);
        console.log("data", data);
      } else {
        // setIsSaving(false);
        console.error("Failed to send answer details...", data);
        setAnswerSubmissionError(true);
      }
    }).catch((err) => {
      console.error("Failed to submit answer...", err);
      if (!navigator.onLine) {
        showSnackbar("You are not connected to the internet. Try again later.", "error");
      } else if (err.message) {
        showSnackbar(err.message, "error");
      } else {
        showSnackbar("Failed to submit answer for Question " + questions?.[activeStep]?.orderNo + ". Please try again later.", "error");
      }
      setAnswerSubmissionError(true);
    });
  }


  const navigatePath = (pgId) => "/assessment/" + id + "/" + pgId + "/?" + searchParams;
  const navigateForwardFunc = () => {
    if (pageId === "28") {
      navigate("/charts/" + id + "/29?" + searchParams, { replace: true });
    } else if (pageId === "30") {
      navigate("/charts/" + id + "/31?" + searchParams, { replace: true });
    } else if (pageId === "32") {
      navigate("/charts/" + id + "/33?" + searchParams, { replace: true });
    } else if (pageId === "34") {
      navigate("/charts/" + id + "/35?" + searchParams, { replace: true });
    } else if (pageId === "36") {
      navigate("/charts/" + id + "/37?" + searchParams, { replace: true });
    } else if (pageId === "804") {
      navigate("/assessment-additional/" + id + "/818?" + searchParams, { replace: true });
    }
  }
  const navigateBackwardFunc = () => {
    let qOrderNum = questions?.[activeStep]?.orderNo;
    console.log("qOrderNum", qOrderNum);
    console.log("pageId", pageId, typeof pageId);

    if (pageId === "28") navigate("/first-form/" + id + "?" + searchParams, { replace: true });
    else if (pageId === "30") {
      if (qOrderNum == 2) navigate("/charts/" + id + "/29?" + searchParams, { replace: true });
      else {
        navigate(navigatePath(28), { replace: true });
        setActiveStep(questions?.length - 1);
      }
    }
    else if (pageId === "32") {
      if (qOrderNum == 5) navigate("/charts/" + id + "/31?" + searchParams, { replace: true });
      else {
        navigate(navigatePath(30), { replace: true });
        setActiveStep(questions?.length - 1);
      }
    }
    else if (pageId === "34") {
      if (qOrderNum == 8) navigate("/charts/" + id + "/33?" + searchParams, { replace: true });
      else {
        navigate(navigatePath(32), { replace: true });
        setActiveStep(questions?.length - 1);
      }
    }
    else if (pageId === "36") {
      if (qOrderNum == 11) navigate("/charts/" + id + "/35?" + searchParams, { replace: true });
      else {
        navigate(navigatePath(34), { replace: true });
        setActiveStep(questions?.length - 1);
      }
    }
    else if (pageId === "38") {
      if (qOrderNum == 14) navigate("/charts/" + id + "/37?" + searchParams, { replace: true });
      else {
        navigate(navigatePath(36), { replace: true });
        setActiveStep(questions?.length - 1);
      }
    } else {
      if (sessionStorage.getItem("external-user") === "true") {
        navigate("/about-infosec/?" + searchParams, { replace: true });
      } else {
        // navigate("/before-you-start/" + id + "?" + searchParams, { replace: true });
        // navigate("/how-it-works/" + id + "?" + searchParams, { replace: true });
        // instead of going to /how-it-works, go back to the very first page with ID
        navigate("/" + id + "?" + searchParams, { replace: true });
      }
    }
  }

  const moveToNextQuestion = (answer) => {

    setQuestions((prevQuestions) => {
      return prevQuestions?.map((q) => {
        if (q.id === questions?.[activeStep]?.id) {
          q.answer = answer;
        }
        return q;
      })
    })
    assessCtx.updateAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answer);
    
    // assessCtx.updateTextAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answerTxt);
    // if(activeStep < questions?.length - 1) {
    //   setTimeout(() => {
    //     setActiveStep(activeStep + 1);
    //   }, 500);
    // } else {
    //   // questions?.[activeStep].answer = answer;
    //   console.log("\n\nSUBMITTING ANSWERS\n\n");
    //   setTimeout(() => { completeAssessment(); }, 500);
    // }

    // setTimeout(() => {
    submitAnswer(answer);
    // }, 250);
    console.log("answer", answer);

  }

  const nextDisabled = () => {
    if (questions?.[activeStep]?.answerType === "textarea" && questions?.[activeStep]?.answerTxt?.length > 0) {
      return { display: "flex" };
    }
    if (questions?.[activeStep]?.answer > 0) {
      return { display: "flex" };
    };
    return { display: "flex" };
  }

  const checkNextBtnDisabled = () => {
    const currentAns = questions?.[activeStep]?.answer;
    const ansType = questions?.[activeStep]?.answerType;
    if (ansType === "textarea" && questions?.[activeStep]?.answerTxt?.length > 0) {
      setNextBtnDisabled(false);
      return;
    }
    if (ansType === "checkbox") {
      const anyOptionChecked = questions?.[activeStep]?.answers?.some(option => option.checked);
      if (anyOptionChecked) {
        setNextBtnDisabled(false);
        return;
      } else {
        setNextBtnDisabled(true);
        return;
      }
    }
    // added isSubmittingAnswer check to prevent enabling Next button while answer is being submitted
    if (ansType === "radio" && currentAns >= 0 && currentAns !== undefined && isSubmittingAnswer === false) {
      setNextBtnDisabled(false);
      return;
    };
    if (showStatistics) {
      setNextBtnDisabled(false);
      return;
    }
    setNextBtnDisabled(true);
  }

  // const nextDisabled = (answer) => {
  //   if(questions?.[activeStep]?.mandatory === "no") {
  //     return {display: "block"};
  //   } else {
  //     // if(questions?.[activeStep]?.answerType == "slider" && questions?.[activeStep]?.answer != 0) {
  //     if(questions?.[activeStep]?.answerType == "slider" && !questions?.[activeStep]?.answer > 0) {
  //       return { display: "block" };
  //     } else if(questions?.[activeStep]?.answerType == "radio" && questions?.[activeStep]?.answer != 0) {
  //       return {display: "block"};
  //     } else if(questions?.[activeStep]?.answerType == "textarea" && questions?.[activeStep]?.answerTxt != "") {
  //       return {display: "block"};
  //     }
  //   } 
  //   return {display: "none"};
  // }

  const updateTextAnswer = (id, textVal) => {
    setQuestions(questions?.map((q) => {
      if (q.id === id) q.answerTxt = textVal;
      return q;
    }))
  }


  const updateCheckboxQuestion = (id, checkboxAnswers) => {
    let value = 0;
    const notaOption = checkboxAnswers?.find(item => item?.desktopText?.toLowerCase()?.trim() === "none of the above");
    if (notaOption.checked) {
      value = 0;
    } else {
      const lengthOfCheckedOptions = checkboxAnswers?.filter(option => option.checked)?.length;
      value = lengthOfCheckedOptions;
    }
    setQuestions(questions?.map((q) => {
      if (q.id === id) {
        q.answers = checkboxAnswers;
        q.answer = value;
      }
      return q;
    }));
  }

  const getQuestionsPerSection = () => {
    let arr = questions?.map(q => q.sectionId);
    let count = {};
    arr?.forEach(element => {
      count[element] = (count[element] || 0) + 1;
    });
    return Object.values(count);
  }

  function getOperatorLogic(operand1, operator, operand2) {
    console.log(operand1, operator, operand2)
    if (operator == '<') {
      return operand1 < operand2;
    } else if (operator == '>') {
      return operand1 > operand2;
    } else if (operator == '||') {
      return operand1 || operand2;
    } else if (operator == '!=') {
      return operand1 != operand2;
    } else if (operator == '==') {
      return operand1 == operand2;
    } else if (operator == '<=') {
      return operand1 <= operand2;
    } else if (operator == '>=') {
      return operand1 >= operand2;
    }
  }

  const getQuestionBasedOnVariable = (array, variable) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].variable == variable) {
        return array[i]
      }
    }
  }

  const questionsPerSection = getQuestionsPerSection();
  // const questionsPerSection = [4, 5, 4, 3];
  console.log("questionsPerSection", questionsPerSection);
  console.log("\n\nquestions?.[activeStep]", activeStep, (questions?.length - 1), "\n\n");
  console.log("assessCtx.questions", assessCtx.questions);
  console.log("questions", questions);


  const getStepContent = (step) => {
    return (
      <Questions question={questions?.[step]} questionCount={questionCount} questionAnswered={moveToNextQuestion} updateTextAnswer={updateTextAnswer} updateCheckboxQuestion={updateCheckboxQuestion} setSelectedAnswer={setSelectedAnswer} />
    );
  };





  const getStatistics = () => {

    const currentStat = questions_statistics?.find(stat => stat.id == questions?.[activeStep]?.orderNo);

    const skipQuestionNumber = [];

    function skipStatistic() {
      setShowStatistics(false);
    }

    if (skipQuestionNumber?.includes(currentStat?.id)) {
      skipStatistic();
    }

    const getDescription = () => {
      return Object.keys(currentStat.desc).filter((key) => {
        return selectedAnswer.toLowerCase() === key.toLowerCase();
      }).map((key) => {
        return currentStat.desc[key];
      });
    };

    let imgStyles = currentStat?.image?.desktop;

    if (windowWidth <= 650) {
      imgStyles = currentStat?.image?.mobile;
    }


    return (
      <div className="statistics">

        {
          currentStat?.mediaPosition === "top" ?
            <>
              <div className="chart">
                {currentStat?.image?.src && <img src={currentStat?.image?.src} alt="" style={imgStyles} />}
                {currentStat?.video?.src && 
                  <VideoContainer videoRef={videoRef} currentStat={currentStat} isVideoPlaying={isVideoPlaying} setIsVideoPlaying={setIsVideoPlaying} imgStyles={imgStyles} />
                }
              </div>

              {currentStat?.title ?
                <p className="chart-title">{currentStat?.title}</p>
                : null
                // <div className="progress-indicator">
                //   <p className="step-no">{questions?.[activeStep]?.orderNo}</p>
                //   /<p className="total-question-count">{questionCount}</p>
                // </div>
              }
              <div className="statistic">
                {/* <div className="circle">
                  <img src={bulbImg} alt="" />
                </div> */}
                {/* <p className="statistic-desc">{getDescription()}</p> */}
                <p className="statistic-desc" >{currentStat?.desc}</p>
              </div>
              
              
              </> :
            <>
              {currentStat?.title ?
                <p className="chart-title">{currentStat?.title}</p>
                : null
                // <div className="progress-indicator">
                //   <p className="step-no">{questions?.[activeStep]?.orderNo}</p>
                //   /<p className="total-question-count">{questionCount}</p>
                // </div>
              }
              <div className="statistic">
                {/* <div className="circle">
                  <img src={bulbImg} alt="" />
                </div> */}
                {/* <p className="statistic-desc">{getDescription()}</p> */}
                <p className="statistic-desc" >{currentStat?.desc}</p>
              </div>
              <div className="chart" style={{marginBottom: "15px" }}>
                {currentStat?.image?.src && <img src={currentStat?.image?.src} alt="" style={imgStyles} />}
                {currentStat?.video?.src && 
                  <VideoContainer videoRef={videoRef} currentStat={currentStat} isVideoPlaying={isVideoPlaying} setIsVideoPlaying={setIsVideoPlaying} imgStyles={imgStyles} />
                }
              </div>


            </>
        }
      </div>
    )
  }

  const nextBtnText = () => {
    const Arrow = <img className="arrow-icon" src={nextArrow} alt="" style={{ paddingLeft: "10px" }} />;
    if (showStatistics) {
      return <><span>Next</span>{Arrow}</>
    } else if (!showStatistics && activeStep < (questions?.length - 1)) {
      let text = "Q" + (parseInt(questions?.[activeStep]?.orderNo) + 1);
      return <>{text}{Arrow}</>;
    } else if (activeStep == (questions?.length - 1)) {
      return <><span>View My Results</span></>;
    }
    return <><span>Next</span>{Arrow}</>;
  }

  const showQuestionsSubtext = (questionNum) => {
    if (questionNum == 8) {
      return (
        <p className='subtext'>
          *Including but not limited to: computers, printers, routers, switches, access points, firewalls, network-attached storage devices, modems, VoIP phones, IP cameras, scanners, IoT devices, unified communications equipment, networked security appliances, and environmental monitoring devices.
        </p>
      );
    }
    return null;
  }

  if (isLoading || isSaving) {
    return <div className="container assessment loading"><CircularProgress style={{ color: "#CC972F" }} size={60} /></div>
  }

  return (
    <>
      <div className="container assessment flex-container" style={{ backgroundColor: showStatistics ? "#242223" : "#FFFFFF" }}>
        <div className="top">
          <ProgressBar currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} questionsPerSection={questionsPerSection} sections={sections} count={questionCount} passiveColor={showStatistics ? "#FFFFFF66" : "#24222333"} />
          {/* {windowWidth < 830 ? <>
            <ProgressBarSingle currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} totalNumOfQuestions={questionCount} />
            <p className="current-section">{currentSectionName}</p>
          </> : <div className="section-progress-top">
            <ProgressBar currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} questionsPerSection={questionsPerSection} sections={sections} count={questionCount} />
          </div>} */}
          <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}></Stepper>
          </Box>
        <div>
          {(!showStatistics) ? <div className="steps-container">
            <div>
              <div className="steps">

                {(windowWidth > 830 && questionType !== "checkbox") && <div className="spacer"></div>}

                {/* {windowWidth > 830 ?
                <>
                  <ProgressBar currentProgress={activeStep} questionsPerSection={questionsPerSection} sections={sections} count={questionCount} />
                  <ProgressBar currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} questionsPerSection={questionsPerSection} sections={sections} count={16} />
                </>
                : <>
                  <ProgressBarSingle currentProgress={activeStep} totalNumOfQuestions={questionCount} />
                  <ProgressBarSingle currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} totalNumOfQuestions={16} />
                  <p className="current-section">{currentSectionName}</p>
                </>
              } */}
                {/* <ProgressBarSingle currentProgress={activeStep} totalNumOfQuestions={questionCount} sections={sections} currentSectionName={currentSectionName} /> */}
                {/* <div className="spacer"></div> */}
                {/* <div className="spacer"></div> */}
                {/* <div className="spacer mobile-spacer"></div> */}
                {/* <div className="spacer mobile-spacer"></div> */}

                {/* <div className="progress-indicator"><strong>{activeStep + 1}</strong>/16</div> */}
                
                {/* <div className="progress-indicator">
                  <p className="step-no">{questions?.[activeStep]?.orderNo}</p>
                  /
                  <p className="total-question-count">{questionCount}</p>
                </div> */}

                {getStepContent(activeStep)}
                {/* <QuestionInfo /> */}

              </div>
            </div>
            <div className="subtext-container">
              {showQuestionsSubtext(questions?.[activeStep]?.orderNo)}
            </div>

          </div> : <>
            {isSubmittingAnswer ? <div className="loading-container"><CircularProgress style={{ color: "#CC972F" }} size={60} /></div> : getStatistics()}
          </>}


        </div>
        </div>
        <div className="mid"></div>
        <div className="bottom">
          <div className="step-buttons" style={{ justifyContent: "space-between" }}>
            <Button onClick={prevQuestion} className="prev-btn" style={{ backgroundColor: showStatistics ? "#242223" : "#FFFFFF", color: showStatistics ? "#FFFFFF" : "#242223", border: showStatistics ? "1px solid #FFFFFF80" : "1px solid #24222366" }}>
              {/* <><img src={prevArrow} alt="previous button" />&nbsp;&nbsp;Prev</> */}
              <><img className="arrow-icon" src={showStatistics ? prevArrow : prevArrowBlack} alt="" style={{ paddingRight: "10px" }} />Prev</>
              {/* <img src={prevArrow} alt="previous button" /> */}
              {/* {windowWidth <= 550 ? (
                <><img src={prevArrow} alt="previous button" />&nbsp;&nbsp;</>
              ) : (
                <><img src={prevArrow} alt="previous button" />&nbsp;&nbsp;</>
              )} */}
            </Button>



            {showNextBtn && <Button className="next-btn" onClick={nextQuestion} disabled={nextBtnDisabled}
            // style={nextDisabled()}
              style={{ color: "#FFFFFF" }}
            >
              {/* <><span>Next</span><img style={{ paddingLeft: "8px" }} src={nextArrowWhite} alt="next button" /></> */}
              {nextBtnText()}
              {/* {windowWidth <= 550 ? (
                <span style={{ fontSize: "18px", }}>NEXT</span>
              ) : (
                <><span style={{ fontSize: "18px", }}>NEXT</span><img style={{ paddingLeft: "8px" }} src={nextArrowWhite} alt="next button" /></>
              )} */}
            </Button>}
          </div>

        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={alertSeverity}
            sx={{ width: "100%" }}
          >
            {errorMsg || "Server error occurred. Please try again later."}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}

export default AssessmentV3;



const VideoContainer = ({ videoRef, currentStat, isVideoPlaying, setIsVideoPlaying, imgStyles }) => {

  const [hasBeenPlayed, setHasBeenPlayed] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = 0.5; // Set to 50%
    }

    if (currentStat?.video?.src) {
      setHasBeenPlayed(false);
    }
  }, [currentStat?.video?.src]);

  const handleCustomPlay = (e) => {
    e.preventDefault();
    if (videoRef.current) {
      videoRef.current.play();
      setIsVideoPlaying(true);
      setHasBeenPlayed(true);
    }
  }

  return <>
    <div className="video-container" style={{ position: "relative" }}>
      <video ref={videoRef} className="video-player" src={currentStat?.video?.src}
        controls={hasBeenPlayed}
        poster={videoThumbnail}
        preload="metadata"
        style={imgStyles} volume={0.5}
        onPlay={() => setIsVideoPlaying(true)}
        onPause={() => setIsVideoPlaying(false)}>
        <source src={currentStat?.video?.src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {!hasBeenPlayed && !isVideoPlaying && currentStat?.video?.src && (
        <div
          className="custom-play-overlay"
          style={{
            position: "absolute", zIndex: 2, cursor: "pointer",
            top: 0, left: 0, width: "100%", height: "100%",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
          onTouchEnd={(e) => {
            e.preventDefault();
            handleCustomPlay(e);
          }}
          onClick={(e) => handleCustomPlay(e)}
        >
          <img src={playBtnImg} className="custom-play-btn"
            alt="Play video icon" aria-label="Play video"
            style={{ pointerEvents: "none" }}
          />
        </div>
      )}

      {/* Pause overlay - only covers the central area */}
      {hasBeenPlayed && !isVideoPlaying && currentStat?.video?.src && (
        <div
          className="center-play-button"
          style={{
            position: "absolute",
            top: "50%", left: "49%",
            transform: "translate(-50%, -50%)",
            zIndex: 2, cursor: "pointer",
            // No width/height = doesn't cover controls
          }}
          onClick={() => {
            if (videoRef.current) {
              videoRef.current.play();
              setIsVideoPlaying(true);
            }
          }}
        >
          <img src={playBtnImg} className="custom-play-btn"
            alt="Play video icon" aria-label="Play video"
            style={{  width: 64, height: 64, opacity: 0.9 }}
          />
        </div>
      )}

      <div className="video-border"></div>
    </div>
    <div className="duration">
      <img src={playIcon} alt="Play video icon" />
      <span>1:36</span>
    </div>
  </>
}
